import { mapGetters } from 'vuex';
import { ManualTankStatusCreateModel } from '../models/tank-status/ManualTankStatusCreateModel';
import dateTimeHelpers from './DateTimeHelpers';

export default {
  data() {
    return {
      updateTankStatusDialog: false,
      tankStatus: {},
    };
  },
  computed: {
    ...mapGetters({
      getUnsyncedTankStatuses: 'dataSyncStore/getUnsyncedTankStatuses',
    }),
    isAnyUnsyncedStatuses() {
      return this.getUnsyncedTankStatuses.length > 0;
    },
  },
  methods: {
    goToTankDetails(tank) {
      this.$router.push({ name: 'tankDetails', params: { id: tank.id } });
    },
    getProgressColourByFillPercent(fillPercent) {
      if (fillPercent >= 85) return 'success';
      if (fillPercent <= 25) return 'error';
      return 'warning';
    },
    openUpdateStatusDialog(tank) {
      this.tankStatus = {
        tankId: tank.id,
        tankBulkType: tank.tankBulkType,
        maxCapacity: tank.maxCapacity,
        tankQtyUom: tank.qtyUom,
        statusDate: dateTimeHelpers.getCurrentDateLt(),
        statusTime: dateTimeHelpers.getCurrentTimeLt(),
        ...tank.currentTankStatus,
        id: null,
        bulkTransactionId: null,
        recordingType: 'Manual',
        vesselName: tank.vesselName
      };
      this.$nextTick(() => {
        this.updateTankStatusDialog = true;
      });
    },
    closeUpdateStatusDialog() {
      this.updateTankStatusDialog = false;
      this.$nextTick(() => {
        this.tankStatus = {};
      });
    },
    submitTankStatus() {
      console.log("Is this where we are?", this.tankStatus);
      return this.$store.dispatch(
        'tanksStore/createTankStatus',
        {
          tankStatus: this.tankStatus,
          manualRecording: true
        })
        .then(() => {
          this.closeUpdateStatusDialog();
          this.onSuccess('Tank Status Submitted');
          if (this.$route.name === 'tankDetails') {
            this.$store.dispatch('tanksStore/loadTankDetails', this.$route.params.id);
          }
        })
        .catch((err) => { this.onError('Failed to Submit Tank Status', err); });
    },
    createTankStatusFromBulkTransaction(transaction, currentTankStatus) {
      let newStatusQuantity;
      const { transactionType, quantity } = transaction;
      const { quantityOnBoard } = currentTankStatus;
      const transactionTypeString = transactionType.toLowerCase();

      if (transactionTypeString === 'loaded' || transactionTypeString === 'generated') {
        newStatusQuantity = parseFloat(quantityOnBoard) + parseFloat(quantity);
      } else if (transactionTypeString === 'delivery' || transactionTypeString === 'consumption' || transactionTypeString === 'dumped') {
        newStatusQuantity = parseFloat(quantityOnBoard) - parseFloat(quantity);
      }

      newStatusQuantity = Math.round((newStatusQuantity + Number.EPSILON) * 1000) / 1000;

      const createdTankStatus = {
        statusDateTimeLt: transaction.completedDateTimeLt,
        bulk: transaction.bulk,
        quantityTransfered: transaction.quantity,
        quantityOnBoard: newStatusQuantity,
        isBackload: false,
        tank: currentTankStatus.tank,
        tankId: transaction.tankId,

        // New Fields
        recordingType: 'Transaction',   // Manual | Transaction
        // Version Fields
        previousVersionId: null,

      };

      //const status = new ManualTankStatusCreateModel(
      //  transaction.completedDateTimeLt,
      //  tankId
      //)

      return createdTankStatus;
    },
    updateTankStatusForBulkTransaction(transaction, oldVersionOfTankStatus) {

      // Is old status synced?
      const previousVersionId = (transaction.Idc) ? null : oldVersionOfTankStatus.id;

      console.log("OLD VERSION", oldVersionOfTankStatus.id, transaction.id);

      // Copy old status and update
      const updatedTankStatus = {
        statusDateTimeLt: transaction.completedDateTimeLt,
        bulk: transaction.bulk,
        quantityOnBoard: 0, // Set this to 0 and cascade changes
        isBackload: false,  // ?
        tank: oldVersionOfTankStatus.tank,
        tankId: oldVersionOfTankStatus.tank.id,

        // New Fields
        recordingType: 'Transaction',   // Manual | Transaction
        recordingSource: 'User',        // User | CascadingChange
        // Version Fields
        previousVersionId,
        tankStatusIdResponsibleForVersion: null,
        // Local indicative only
        isFrontendOnly: false,

      };

      return updatedTankStatus;
    },
    deleteTankStatusForBulkTransaction(transaction, oldVersionOfTankStatus) {
      // Can we find the old version?
      // Yes: Make copy, mark as deleted
      // No: Backend will take care of it when deleting bulk transaction
    },
    recalculateTotals(tankId, tankStatus) {
      // Cycle through tank statuses from the manual closest
      // to the target and retotal. Create cascading edits
      // but mark them as isFrontendOnly = true so that the
      // server can disregard them and create canonical
      // version.
    },
    onSuccess(message) {
      this.$toast.success(message);
    },
    onError(message, err) {
      this.$toast.error(message);
    },
  },
};
